<template>
  <div>
    <vue-select style="width: 100%;font-size: var(--font-primary);" :placeholder="$t('Seçin')" :disabled="off" filterable :value="selected"
      @input="handleInput" :clearable="true" :options="data" label="name" :option-key="'id'" :reduce="data => data.id">
    </vue-select>
  </div>
</template>

<script>
import { GetInsuranceCompanies } from "../../services/cls";
export default {
  props: {
    value: [Number, String],
    disabled: Boolean,
  },
  data() {
    return {
      data: [],
      selected: this.value,
      off: this.disabled,
    };
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },

    getData() {
      GetInsuranceCompanies().then((response) => {
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Insurance Companies: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    disabled() {
      this.off = this.disabled;
    },
  },
};
</script>
<style>
/* 
.vs__search, .vs__search:focus {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    border: 1px solid transparent;
    border-left: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #565f74!important;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    font-size:0.8rem  !important;
    line-height: var(--vs-line-height);
    margin: 4px 0 0;
    max-width: 100%;
    outline: none;
    padding: 0 7px;
    width: 0;
    z-index: 1;
    margin-left: 5px !important;
}
.vs__selected {
  -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: var(--vs-selected-bg);
    border: var(--vs-selected-border-width) var(--vs-selected-border-style) rgb(204 124 124 / 26%);
    border-radius: var(--vs-border-radius);
    color:  #343232!important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: var(--vs-line-height);
    margin: 4px 2px 0;
    padding: 0 .25em;
    z-index: 0;
    margin-left: 10px !important;
}

#my-select .vue-select .vs__dropdown-toggle,
.vue-select .vs__dropdown-menu .vs__option {
  font-size: 12px !important;
}

.vs__clear {
  display: none;
} */
</style>
